import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import { useHistory } from "react-router-dom";
import { NavLink } from 'react-router-dom';
import { toggleModal } from "../../store/actions/toggleModalActions";
import { isAdminUser } from "../../helpers/helpers";
import './SideBar.scss';

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    };
};

const SideBar = props => {
    const { t } = useSelector(selector);
    const { showMenuLabels } = props;
    const dispatch = useDispatch();
    const history = useHistory();

    const logOut = () => {
        sessionStorage.clear();
        dispatch(toggleModal(false, ''))
        history.push('/start');
    };

    return (
        <nav className={showMenuLabels ? 'sidebar sidebar--extended' : 'sidebar'}>

            <ul className='appNav'>

                <li className='appNavItem'>
                    <NavLink exact to='/' className='appNavLink'>
                        <div className='appNavItemIconHolder'>
                            <span className="material-icons appNavItemIcon">
                                sensors
                            </span>
                        </div>
                        <div className='appNavItemLabel'>
                            {t.gettext('Meteo stations management')}
                        </div>
                    </NavLink>
                </li>

                <li className='appNavItem'>
                    <NavLink exact to='/comments' className='appNavLink'>
                        <div className='appNavItemIconHolder'>
                            <span className="material-icons appNavItemIcon">
                                comment
                            </span>
                        </div>
                        <div className='appNavItemLabel'>
                            {t.gettext('IPSAD comments')}
                        </div>
                    </NavLink>
                </li>

                <li className='appNavSeparator' />

                {isAdminUser() &&
                    <li className='appNavItem'>
                        <NavLink exact to='/users' className='appNavLink'>
                            <div className='appNavItemIconHolder'>
                                <span className="material-icons appNavItemIcon">
                                    group
                                </span>
                            </div>
                            <div className='appNavItemLabel'>
                                {t.gettext('Users management')}
                            </div>
                        </NavLink>
                    </li>
                }

                <li className='appNavItem'>
                    <NavLink exact to='/login' className='appNavLink' onClick={logOut}>
                        <div className='appNavItemIconHolder'>
                            <span className="material-icons appNavItemIcon">
                                power_settings_new
                            </span>
                        </div>
                        <div className='appNavItemLabel'>
                            {t.gettext('Log out')}
                        </div>
                    </NavLink>
                </li>

            </ul>
        </nav>
    );
};

export default SideBar;
